<template>
  <div class="dateSelect">
    <img
      @click="changeMonth('last')"
      src="../../../assets/images/l_icon.png"
      alt="上一年"
    />
    <div style="color: #ff9901">{{ formatting(dateVlue) }}</div>
    <img
      @click="changeMonth('next')"
      src="../../../assets/images/r_icon.png"
      alt="下一年"
    />
  </div>
</template>

<script>
import moment from "moment";
export default {
  model: {
    prop: "value",
    event: "model",
  },
  props: {
    value: String,
    format: {
      type: String,
      defaultValue: "YYYY-MM-DD",
    },
  },
  data() {
    return {
      dateVlue: "",
      type: "day",
    };
  },
  mounted() {
    this.dateVlue = this.value || moment().format(this.format);
    if (this.format === "YYYY-MM") {
      this.type = "month";
    } else if (this.format === "YYYY") {
      this.type = "year";
    } else {
      this.type = "day";
    }
  },
  methods: {
    formatting(value) {
      if (this.format === "YYYY-MM") {
        return moment(value).format("YYYY年MM月");
      } else if (this.format === "YYYY") {
        return moment(value).format("YYYY年");
      } else {
        return moment(value).format("YYYY年MM月DD日");
      }
    },
    changeMonth(type) {
      if (type === "last") {
        this.dateVlue = moment(this.dateVlue)
          .subtract(1, this.type)
          .format(this.format);
      } else {
        this.dateVlue = moment(this.dateVlue).add(1, this.type).format(this.format);
      }
      this.$emit("model", this.dateVlue);
      this.$emit("change", this.dateVlue);
    },
  },
};
</script>
<style scoped>
.dateSelect {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  background: #fff;
}
.dateSelect > img {
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/salesdata/components/YMselect.vue